import { Component } from "@angular/core";
import { SafeHtmlPipe } from "primeng/menu";
import { authInfoCards } from "../../models/auth-info.models";

@Component({
	selector: "app-auth-info-cards",
	imports: [SafeHtmlPipe],
	templateUrl: "./auth-info-cards.component.html",
	styleUrl: "./auth-info-cards.component.css",
})
export class AuthInfoCardsComponent {
	protected infoCards = authInfoCards;
}
